import React from "react";
import "./ActivityCard.css"

function ActivityCard({ image }) {
  return (
    <div className="ActivityCard">
     

      <div className="card_image">
        <img src={image} className="card_img" />
      </div>
    </div>
  );
}

export default ActivityCard;